module.exports = __webpack_public_path__ + "static/media/GAMKONORA_ch2_20210921065649_T.0cff180e.jpg";